export interface LayoutItem {
  position: [number, number, number];
  rotation: [number, number, number];
  scale: [number, number, number];
}

export type SceneLayout = Record<string, LayoutItem>;

// Standing desk: 1.601 wide × 1.098 tall × 0.775 deep at scale [1,1,1]
// Surface Y ≈ 1.097, desk spans X[-0.80, 0.80], Z[-0.41, 0.37]
const S = 1.1;

export const DEFAULT_LAYOUT: SceneLayout = {
  // Room environment
  room:     { position: [0, -0.067, 0],                   rotation: [0, 0, 0],                    scale: [1, 1, 1] },
  // Physical desk items
  desk:     { position: [0, 0, 0],                       rotation: [0, 0, 0],                    scale: [1, 1, 1] },
  monitor:  { position: [-0.087, S, -0.084],             rotation: [0, 0, 0],                    scale: [2.2, 2.2, 2.2] },
  keyboard: { position: [-0.291, S, 0.245],              rotation: [0, 0, 0],                    scale: [2, 2, 2] },
  mouse:    { position: [0.520, S, 0.228],               rotation: [0, 0, 0],                    scale: [2, 2, 2] },
  laptop:   { position: [-0.583, S, 0.071],              rotation: [0, 0.35, 0],                 scale: [1.9, 1.9, 1.9] },
  headset:  { position: [1.346, 1.049, 0.115],           rotation: [-1.636, 0, 0],               scale: [0.015, 0.015, 0.015] },
  plant:    { position: [-0.982, 0.015, -0.089],         rotation: [0, 0, 0],                    scale: [1.5, 1.5, 1.5] },
  sm7bBase:      { position: [-0.70, S, 0.10],            rotation: [0, 0, 0],                       scale: [1, 1, 1] },
  sm7bStand:     { position: [-0.70, S, 0.10],            rotation: [0.074, 0.024, 0],               scale: [1, 1, 1] },
  sm7bBoom:      { position: [-0.70, S, 0.10],            rotation: [0, -0.065, 0],                  scale: [1, 1, 1] },
  sm7bBody:      { position: [-0.715, 1.785, -0.251],     rotation: [-0.776, -0.396, -2.017],        scale: [1, 1, 1] },
  sm7bWindscreen:{ position: [-0.70, S, 0.10],            rotation: [0, 0, 0],                       scale: [1, 1, 1] },
  webcam:   { position: [0.010, 1.75, -0.241],           rotation: [0, 0, 0],                    scale: [1, 1, 1] },
  pcTower:  { position: [1.2, 0, 0],                     rotation: [3.142, -1.559, 3.142],       scale: [1, 1, 1] },
  piano:    { position: [-0.944, 1.563, 1.219],          rotation: [-3.111, 1.472, 3.101],       scale: [1.45, 1.45, 1.45] },
  // Floating category bubbles
  bubbleEditorIDE:       { position: [-1.5, 1.575, 0.8],    rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleTerminal:        { position: [-0.5, 1.790, -1.498], rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleBrowser:         { position: [1.5, 1.738, -1.152],  rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleProductivity:    { position: [2.0, 1.549, 0.5],     rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleDevTools:        { position: [1.335, 1.587, 1.5],   rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleInfrastructure:  { position: [0, 1.739, 2.0],       rotation: [0, 0, 0], scale: [1, 1, 1] },
  bubbleAI:              { position: [-1.8, 1.650, -0.8],   rotation: [0, 0, 0], scale: [1, 1, 1] },
};

export const ITEM_LABELS: Record<string, string> = {
  room: 'Room', desk: 'Standing Desk', monitor: 'Monitor', keyboard: 'Keyboard',
  mouse: 'Mouse', laptop: 'Laptop', headset: 'Gaming Headset', plant: 'Plant',
  sm7bBase: 'SM7B Base', sm7bStand: 'SM7B Stand', sm7bBoom: 'SM7B Boom Arm',
  sm7bBody: 'SM7B Body', sm7bWindscreen: 'SM7B Windscreen',
  webcam: 'Webcam', pcTower: 'PC Tower', piano: 'Electric Piano',
  bubbleEditorIDE: 'Editor & IDE Bubble', bubbleTerminal: 'Terminal Bubble',
  bubbleBrowser: 'Browser Bubble', bubbleProductivity: 'Productivity Bubble',
  bubbleDevTools: 'Dev Tools Bubble', bubbleInfrastructure: 'Infrastructure Bubble',
  bubbleAI: 'AI Bubble',
};
